import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  title?: string
  label?: string
}

export const RenderItem = ({ title, label }: Props) => (
  <div className={s.itemWrapper}>
    <span className={clsx('regular-13', s.itemLabel)}>{label}</span>
    <p className={clsx('regular-17', s.itemValue)}>{title}</p>
  </div>
)
